// extracted by mini-css-extract-plugin
export default {"panel":"AddImage_panel__sR+8x","panel_body":"AddImage_panel_body__GBf2o","radio":"AddImage_radio__EpuBd","image":"AddImage_image__WrCQE"};